import { useQuery } from "react-query";
import { getOfficeHours } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetOfficeHours = () => {
  return useQuery(
    ["GetOfficeHours"],  getOfficeHours,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetOfficeHours;
